var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      ref: _vm.refs,
      staticStyle: { width: "100%" },
      attrs: {
        clearable: _vm.clearable,
        "allow-create": _vm.allowCreate,
        "default-first-option": "",
        disabled: _vm.disabled,
        multiple: _vm.multiple,
        filterable: "",
        placeholder: _vm.placeholder,
        remote: "",
        "remote-method": _vm.remoteMethod,
        loading: _vm.loading
      },
      on: { focus: _vm.focus, change: _vm.selectChange },
      model: {
        value: _vm.id,
        callback: function($$v) {
          _vm.id = $$v
        },
        expression: "id"
      }
    },
    [
      _vm.showNone
        ? _c("el-option", { attrs: { label: "未设置", value: "0" } })
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.list, function(item, index) {
        return _c(
          "el-option",
          { key: index, attrs: { label: item.name, value: item.id } },
          [
            _c(
              "span",
              {
                attrs: { title: item.subjectCatalogueName },
                on: { click: _vm.optionClick }
              },
              [
                _vm._v("\n      " + _vm._s(item.name) + "\n      "),
                item.knowledgePointChildCount
                  ? _c("small", { staticStyle: { color: "#bbb" } }, [
                      _vm._v(
                        "（" +
                          _vm._s(item.knowledgePointChildCount) +
                          "个子知识点）"
                      )
                    ])
                  : _vm._e()
              ]
            )
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2681a43c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2681a43c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KnowledgeList.vue
// module id = 564
// module chunks = 14